import OutcomesHeader from './outcomes_header_redux';

export default OutcomesHeader;
